import React, { FC } from 'react';

import classes from 'classnames';

import { IAddMinusButtonProps } from 'components/shared/AddMinusButton/types';
import Icon from 'components/shared/Icon';
import CircleMinusIcon from 'components/shared/Icon/icons/CircleMinusIcon';
import CirclePlusIcon from 'components/shared/Icon/icons/CirclePlusIcon';

import styles from './index.module.css';

const chooseSize = (size?: string) => {
  switch (size) {
    case 'small':
      return '1.2rem';
    case 'large':
      return '4rem';
    default:
      return '2.8rem';
  }
};

const AddMinusButton: FC<IAddMinusButtonProps> = ({
  type = 'button',
  onClick,
  iconComponent,
  className,
  variant = 'add',
  size,
}) => {
  const buttonClasses = classes(styles.button, className, 'custom-add-minus-button');
  const iconSize = chooseSize(size);

  const icon =
    variant === 'add' ? (
      <Icon
        width={iconSize}
        height={iconSize}
        component={iconComponent || CirclePlusIcon}
        className={classes(styles.icon, 'custom-add-minus-button-icon')}
      />
    ) : (
      <Icon
        width={iconSize}
        height={iconSize}
        component={iconComponent || CircleMinusIcon}
        className={classes(styles.icon, 'custom-add-minus-button-icon')}
      />
    );

  return (
    <button type={type} onClick={onClick} className={buttonClasses} tabIndex={-1}>
      {icon}
    </button>
  );
};

export default AddMinusButton;
